import React, {Component} from 'react';
// import TextField from 'material-ui/TextField';
import {InputText} from '../../blocks/inputs/InputText';
import { inject, observer } from 'mobx-react';
import Checkbox from 'material-ui/Checkbox';
import checkedIcon from 'images/checked.svg';
// import Player from '@vimeo/player';
// import ReactPlayer from 'react-player';

@inject('topicsStore')
@inject('userStore')
@observer
class Podcast extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // podcast_title: '',
      // podcast_description: '',
      // podcast_url: '',
      showInputs: false,
      podcasts_attributes: [],
      deletedPodcasts: []
    };
  }

  // componentDidMount() {
  //   const {topicsStore} = this.props;
  //   this.setState({
  //     podcast_title: topicsStore.topic.podcast_title,
  //     podcast_description: topicsStore.topic.podcast_description,
  //     podcast_url: topicsStore.topic.podcast_url,
  //   });
  // }

  componentDidMount() {
    const {topicsStore} = this.props;
    this.setState({
      podcasts_attributes: topicsStore.topic.podcasts_attributes
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    const {topicsStore} = this.props;
    if(!prevState.podcasts_attributes[0] &&
      prevState.podcasts_attributes.length < topicsStore.topic.podcasts_attributes.length
    ) {
      this.setState({
        podcasts_attributes: topicsStore.topic.podcasts_attributes
      });
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   const {topicsStore} = this.props;
  //   if(!prevState.podcast_title && topicsStore.topic.podcast_title) {
  //     this.setState({
  //       podcast_title: topicsStore.topic.podcast_title,
  //       podcast_description: topicsStore.topic.podcast_description,
  //       podcast_url: topicsStore.topic.podcast_url,
  //     });
  //   }
  // }

  handleChange = index => e => {
    const {podcasts_attributes} = this.state;
    const new_podcasts_attributes = [...podcasts_attributes];
    let new_podcasts_attribute = {...new_podcasts_attributes[index]};
    new_podcasts_attribute = {
      ...new_podcasts_attribute,
      [e.target.name]: e.target.value
    };
    new_podcasts_attributes[index] = {...new_podcasts_attribute};
    this.setState({podcasts_attributes: new_podcasts_attributes});
  }

  updateCheck = index => () => {
    const {podcasts_attributes} = this.state;
    const new_podcasts_attributes = [...podcasts_attributes];
    let new_podcasts_attribute = {...new_podcasts_attributes[index]};

    new_podcasts_attribute = {
      ...new_podcasts_attribute,
      is_published: !new_podcasts_attribute.is_published
    };
    new_podcasts_attributes[index] = {...new_podcasts_attribute};
    this.setState({podcasts_attributes: new_podcasts_attributes});
  }

  // handleChange = e => {
  //   this.setState({[e.target.name]: e.target.value});
  // }

  // deletePodcast = () => {
  //   this.setState({
  //     podcast_title: '',
  //     podcast_description: '',
  //     podcast_url: '',
  //     showInputs: true,
  //   });
  //   this.props.topicsStore.handleChange({
  //     podcast_title: '',
  //     podcast_description: '',
  //     podcast_url: '',
  //   });
  // }

  deletePodcast = index => () => {
    const {podcasts_attributes, deletedPodcasts} = this.state;
    const new_podcasts_attributes = [...podcasts_attributes];
    let deletedPodcast = new_podcasts_attributes.splice(index, 1)[0];
    deletedPodcast = {...deletedPodcast, _destroy: true};
    deletedPodcasts.push(deletedPodcast);
    this.setState({podcasts_attributes: new_podcasts_attributes, deletedPodcast});
    this.props.topicsStore.handleChange({podcasts_attributes: [...new_podcasts_attributes, ...deletedPodcasts]});
  }

  updateUrl = () => {
    const {podcasts_attributes} = this.state;
    this.setState({showInputs: false});
    this.props.topicsStore.handleChange({podcasts_attributes});
  }

  // updateUrl = () => {
  //   const {podcast_title, podcast_description, podcast_url} = this.state;
  //   this.setState({showInputs: false});
  //   this.props.topicsStore.handleChange({podcast_title, podcast_description, podcast_url});
  // }

  showPodcastInputs = () => {
    this.setState({showInputs: true});
  }

  addPodcast = () => {
    const {podcasts_attributes} = this.state;
    const new_podcasts_attributes = [...podcasts_attributes]
    new_podcasts_attributes.push({
        title: '',
        description: '',
        podcast_url: '',
        is_published: false
    });
    this.setState({podcasts_attributes: new_podcasts_attributes});
  }

  renderNoPodcast = () => (
    this.props.userStore.isAdmin() ?
      <div className="row justify-content-start video-save video-fields col-12">
        <button onClick={this.addPodcast}>
          + Add one more podcast
        </button>
      </div> : null
  )

  renderEmbeded = url => {
    return <div dangerouslySetInnerHTML={{__html: url}}></div>
  }

  render() {
    const {userStore, topic} = this.props;
    const {
      podcasts_attributes,
      showInputs
    } = this.state;
    // const podcast = topic ? topic.podcast_url : podcast_url;

    return (
      <div className="tab-container" style={userStore.isAdmin() ? {} : {marginTop: '42px'}}>
        <div className="row">
          { userStore.isAdmin() && (!topic.podcasts_attributes[0] || showInputs) ? (
              <div className="col-12 container-body">
                {podcasts_attributes.map((podcast, index) => (
                  <div className="video-fields" key={index}>
                    <div className="row justify-content-start video-fields col-12">
                      <h3 className='container-header'>{podcast.title ? podcast.title : 'Add Podcast'}</h3>
                      <button className='delete-btn' onClick={this.deletePodcast(index)}>
                        Delete
                      </button>
                    </div>
                    <div className='col-sm-12'>
                      <Checkbox
                        label=''
                        checked={podcast.is_published}
                        onCheck={this.updateCheck(index)}
                        color='#467093'
                        checkedIcon={<img src={checkedIcon} />}
                      />
                      <span>Publish on Homepage: Yes / No</span>
                    </div>
                    <div className="col-sm-12">
                      <InputText
                        name='title'
                        label='Podcast title'
                        placeholder='Podcast title'
                        fullWidth={true}
                        onChange={this.handleChange(index)}
                        value={podcast.title}
                      />
                    </div>
                    <div className="col-sm-12">
                      <InputText
                        name='description'
                        label='Podcast description'
                        placeholder='Podcast description'
                        fullWidth={true}
                        onChange={this.handleChange(index)}
                        value={podcast.description}
                      />
                    </div>
                    <div className="col-sm-12">
                      <InputText
                        name='podcast_url'
                        label='Podcast URL'
                        placeholder='Podcast URL'
                        fullWidth={true}
                        onChange={this.handleChange(index)}
                        value={podcast.podcast_url}
                      />
                    </div>
                  </div>
                ))}
                <div className="row justify-content-start video-save video-fields col-12">
                  <button onClick={this.addPodcast}>
                    + Add one more podcast
                  </button>
                </div>
                <div className="row justify-content-center video-save">
                  <button onClick={this.updateUrl} className="btn-new-main">Update</button>
                </div>
              </div>
            ) : (
              podcasts_attributes && podcasts_attributes.length > 0 ? podcasts_attributes.map((podcast, index) => (
                <div className="col-12 container-body" style={userStore.isAdmin() ? {} : {marginTop: '42px'}} key={index}>
                  <div className="row justify-content-start col-12">
                    <h3 className='container-header'>{podcast.title}</h3>
                  </div>
                  <p>{podcast.description}</p>
                  <div className="video-embed" style={{boxShadow: '0 2px 20px 0 rgba(0, 0, 0, 0.23)', paddingBottom: 0}}>
                    <div className="frame-wrapper">
                      {this.renderEmbeded(podcast.podcast_url)}
                    </div>
                  </div>
                  { userStore.isAdmin() &&
                    <div className="row justify-content-center edit-controlls video-save">
                      <button className='delete' onClick={this.deletePodcast(index)}>delete</button>
                      <button className='create' onClick={this.showPodcastInputs}>edit podcast</button>
                    </div>
                  }
                </div>
              )) : this.renderNoPodcast()
            )
          }
        </div>
      </div>
    );
  }
}

export default Podcast;


// WEBPACK FOOTER //
// ./src/modules/topic/components/PodcastInputs.js